import styled from 'styled-components';

const IconContainer = styled.div`
  --scale-factor: 1.5;

  & svg {
    transform: scale(var(--scale-factor));
  }
`;

export default IconContainer;